

app.controller('CIF-CTRL',
    ['$scope', '$rootScope', '$http', '$window', '$timeout', '$q', '$filter',
    function ($scope, $rootScope, $http, $window, $timeout, $q, $filter) {

    $scope.CIFInvestor = {
        Sex: '',
        Religion: '',
        MaritalStatus: '',
        Education: '',
    }


    $scope.CIFInvestor.PhoneCode = '+62';
    $scope.maxDate = new Date().toISOString().slice(0, 10);
    $scope.Kewarganegaraan = 'WNI / Indonesia';
    $scope.KewarganegaraanOption = ['WNI / Indonesia', 'Lainnya / Others'];
    $scope.IDLength = 16;
    $scope.chkSeumurHidup = true;
    $scope.DisabledSeumurHidup = true;

    $scope.IDCardCitySelected = '';
    $scope.DomicileCitySelected = '';
    $scope.NationalitySelected = '';
    $scope.IDCardCountrySelected = '';
    $scope.IDCardKecamatanSelected = '';
    $scope.SalesSelected = '';

    $scope.ListNationality = [];
    $scope.ListLookup = [];
    $scope.ListReligion = [];
    $scope.ListMarital = [];
    $scope.ListEducation = [];
    $scope.ListKecamatan = [];
    $scope.ListKecamatanDomicile = [];
    $scope.ListKecamatanAll = [];
    $scope.ListKelurahan = [];
    $scope.ListKelurahanDomicile = [];

    $scope.selectSales = function (item, model, label, event) {
        if (item.SalesPersonNID) {
            $scope.CIFInvestor.Sales = item.SalesPersonNID;
            $scope.SalesSelected = item;

        }

    };


    $scope.KewarganegaraanChange = function () {
        if ($scope.Kewarganegaraan == 'WNI / Indonesia') {
            $scope.IDLength = 16;
            $scope.chkSeumurHidup = true;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 102;
            $scope.CIFInvestor.IDCardCountry = 102;
            $scope.CIFInvestor.CopyID = true;
            $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
        }
        else if ($scope.Kewarganegaraan == 'Lainnya / Others') {
            $scope.IDLength = 8;
            $scope.chkSeumurHidup = false;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 0;
            $scope.CIFInvestor.IDCardCountry = 0;
            $scope.CIFInvestor.CopyID = false;
            $scope.CIFInvestor.IDCardExpireDate = '';
            $scope.CIFInvestor.IDCardCity = 0;
            $scope.CIFInvestor.IDCardKecamatan = '';
            $scope.CIFInvestor.IDCardKelurahan = '';
            $scope.CIFInvestor.IDCardRT = '';
            $scope.CIFInvestor.IDCardRW = '';
            $scope.CIFInvestor.IDCardAddress = '';
            $scope.IDCardCitySelected = '';
        }
    }


    $scope.selectNationality = function (item, model, label, event) {
        if (item.CIFCountryNID) {
            $scope.CIFInvestor.Nationality = item.CIFCountryNID;
            $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;
            $scope.NationalitySelected = item;
            $scope.IDCardCountrySelected = item;
        }

    };

    $scope.selectIDCardCountry = function (item, model, label, event) {
        if (item.CIFCountryNID) {
            $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;
        }
    };

    $scope.selectIDCardCity = function (item, model, label, event) {
        $scope.ListKecamatan = '';
        $scope.ListKelurahan = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.IDCardCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatan = data.data.d;
                $scope.kecamatanChange();
            }, function (error) { });

        }

    };

    $scope.selectDomicileCity = function (item, model, label, event) {
        $scope.ListKecamatanDomicile = '';
        $scope.ListKelurahanDomicile = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.DomicileCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatanDomicile = data.data.d;
                $scope.kecamatanChange();
            }, function (error) { });
        }

    };

    $scope.kecamatanChange = function () {
        if ($scope.CIFInvestor.IDCardKecamatan) {
            $scope.ListKelurahan = $filter('filter')($scope.ListKecamatan, { Kecamatan: $scope.CIFInvestor.IDCardKecamatan }, true);
        }
    }

    $scope.kelurahanChange = function () {
        if ($scope.CIFInvestor.IDCardKelurahan) {
            let temp = $filter('filter')($scope.ListKecamatan, { Kelurahan: $scope.CIFInvestor.IDCardKelurahan }, true);
            if (temp) {
                $scope.CIFInvestor.IDCardPostalCode = temp[0].PostalCode;
            }
        }
    }

    $scope.kecamatanDomicileChange = function () {
        if ($scope.CIFInvestor.DomicileKecamatan) {
            $scope.ListKelurahanDomicile = $filter('filter')($scope.ListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.DomicileKecamatan }, true);
        }
    }

    $scope.kelurahanDomicileChange = function () {
        if ($scope.CIFInvestor.DomicileKelurahan) {
            let temp = $filter('filter')($scope.ListKecamatanDomicile, { Kelurahan: $scope.CIFInvestor.DomicileKelurahan }, true);
            if (temp) {
                $scope.CIFInvestor.DomicilePostalCode = temp[0].PostalCode;
            }
        }
    }

    $scope.CopyFromID = function () {
        if ($scope.CIFInvestor.CopyID) {
            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
            $scope.DomicileCitySelected = $scope.IDCardCitySelected;
        }
        else {
            $scope.CIFInvestor.DomicilePostalCode = '';
            $scope.CIFInvestor.DomicileAddress = '';
            $scope.CIFInvestor.DomicileRT = '';
            $scope.CIFInvestor.DomicileRW = '';
            $scope.CIFInvestor.DomicileKelurahan = '';
            $scope.CIFInvestor.DomicileKecamatan = '';
            $scope.CIFInvestor.DomicileCity = 0;
            $scope.DomicileCitySelected = '';
        }

    };

    $scope.mustSelect = function (event, field) {
        if (event.keyCode == 27) {
            let returnValue = true;
            switch (field) {
                case 'IDCard': $scope.CIFInvestor.IDCardCity = ''; returnValue = false;
                    break;
                case 'Domicile': $scope.CIFInvestor.DomicileCity = ''; returnValue = false;
                    break;
                case 'Correspondence': $scope.CIFInvestor.CorrespondenceCity = ''; returnValue = false;
                    break;
                default:
                    break;
            }
            return returnValue;
        }
        return true;
    }



    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: 'service/client.svc/retrieveSession',
        }).then(function (data) {
            if (!data.data.d) {
                $http({
                    method: 'GET',
                    url: 'service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
            else
                $scope.currentUser = data.data.d;
        }, function (error) { }),

        //$http({
        //    method: 'GET',
        //    url: 'service/client.svc/GetPED',
        //}).then(function (data) {

        //    if (data.data.d != null) {
        //        $scope.broker = data.data.d;
        //        $scope.user.BrokerCode = $scope.broker.BROKERCode;
        //    }
        //}, function (error) { }),

        $http({
            method: 'GET',
            url: 'service/client.svc/GetCIFCountry',
            cache: true,
        }).then(function (data) {
            $scope.ListNationality = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: 'service/client.svc/GetCIFCountryAll',
            cache: true,
        }).then(function (data) {
            $scope.ListCountry = data.data.d;
        }, function (error) { }),
         $http({
             method: 'GET',
             url: 'service/client.svc/GetCIFSales',
             cache: false,
         }).then(function (data) {
             $scope.ListSales = data.data.d;
         }, function (error) { }),
         $http({
             method: 'GET',
             url: 'service/client.svc/GetPED',
         }).then(function (data) {

             if (data.data.d != null) {
                 $scope.broker = data.data.d;
             }
         }, function (error) { }),
        $http({
            method: 'GET',
            url: 'service/client.svc/GetCIFProvinceCity',
            cache: true,
        }).then(function (data) {
            $scope.ListProvinceCity = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: 'service/client.svc/GetCIFLookup',
            cache: true,
        }).then(function (data) {
            $scope.ListLookup = data.data.d;
            if ($scope.ListLookup) {
                $scope.ListReligion = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Religion' }, true);
                $scope.ListMarital = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                $scope.ListEducation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Educational' }, true);
                $scope.ListAssets = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Assets' }, true);
                $scope.ListMonthlyCostLiving = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
            }
        }, function (error) { }),

    ]);



    allPromise.then(function () {
        $http({
            method: 'GET',
            url: 'service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 1;

                if ($scope.CIFInvestor.Sex == 0)
                    $scope.CIFInvestor.Sex = '';

                if ($scope.CIFInvestor.Religion == 0)
                    $scope.CIFInvestor.Religion = '';

                if ($scope.CIFInvestor.MaritalStatus == 0)
                    $scope.CIFInvestor.MaritalStatus = '';

                if ($scope.CIFInvestor.Education == 0)
                    $scope.CIFInvestor.Education = '';

                if ($scope.CIFInvestor.MonthlyCostLiving == 0)
                    $scope.CIFInvestor.MonthlyCostLiving = 0;

                if ($scope.CIFInvestor.Assets == 0)
                    $scope.CIFInvestor.Assets = 0;

                if (data.data.d.BirthDate)
                    $scope.CIFInvestor.BirthDate = new Date(data.data.d.BirthDate);



                if (data.data.d.IDCardCity) {
                    $scope.IDCardCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.IDCardCity }, true)[0];
                    $http({
                        method: 'GET',
                        url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.IDCardCity,
                        cache: true,
                    }).then(function (dataKecamatan) {
                        $scope.ListKecamatan = dataKecamatan.data.d;
                        if ($scope.ListKecamatan)
                            $scope.ListKelurahan = $filter('filter')($scope.ListKecamatan, { Kecamatan: $scope.CIFInvestor.IDCardKecamatan }, true);
                    }, function (error) { });
                }



                if (data.data.d.DomicileCity) {
                    $scope.DomicileCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.DomicileCity }, true)[0];
                    $http({
                        method: 'GET',
                        url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.DomicileCity,
                        cache: true,
                    }).then(function (dataKecamatanDomisili) {
                        $scope.ListKecamatanDomicile = dataKecamatanDomisili.data.d;
                        if ($scope.ListKecamatanDomicile)
                            $scope.ListKelurahanDomicile = $filter('filter')($scope.ListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.DomicileKecamatan }, true);
                    }, function (error) { });
                }


                if (data.data.d.Sales) {
                    $scope.SalesSelected = $filter('filter')($scope.ListSales, { SalesPersonNID: data.data.d.Sales }, true)[0];
                }


                if (data.data.d.Nationality) {
                    if (data.data.d.Nationality == 102) {
                        $scope.IDLength = 16;
                        $scope.chkSeumurHidup = true;
                        $scope.DisabledSeumurHidup = true;
                        $scope.CIFInvestor.Nationality = 102;
                        $scope.CIFInvestor.IDCardCountry = 102;
                        $scope.Kewarganegaraan = $scope.KewarganegaraanOption[0];
                        $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
                    }
                    else {
                        $scope.IDLength = 8;
                        $scope.chkSeumurHidup = false;
                        $scope.DisabledSeumurHidup = true;
                        $scope.Kewarganegaraan = $scope.KewarganegaraanOption[1];
                        $scope.NationalitySelected = $filter('filter')($scope.ListNationality, { CIFCountryNID: data.data.d.Nationality }, true)[0];
                        $scope.IDCardCountrySelected = $filter('filter')($scope.ListCountry, { CIFCountryNID: data.data.d.IDCardCountry }, true)[0];

                        if (data.data.d.IDCardExpireDate)
                            $scope.CIFInvestor.IDCardExpireDate = new Date(data.data.d.IDCardExpireDate);
                    }
                }
                else
                    $scope.KewarganegaraanChange();

                if (data.data.d.CopyID)
                    $scope.CopyFromID();

                var SWALtranslate = $scope.SWALtranslate('ocr');

                Swal.fire({
                    title: SWALtranslate.title,
                    text: SWALtranslate.message,
                    imageUrl: 'dist/images/sync-animate.svg',
                    imageAlt: 'Preparation',
                    imageHeight: 250,
                    animation: false
                });


            } // END IF data.data.d
        }, function (error) { });
    });

    $scope.prepareData = function () {
        if ($scope.CIFInvestor.CopyID) {
            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
            $scope.DomicileCitySelected = $scope.IDCardCitySelected;
        }

        if ($scope.SalesSelected)
            $scope.CIFInvestor.Sales = $scope.CIFInvestor.Sales;

        if ($scope.CIFInvestor.AccountStatus)
            $scope.CIFInvestor.AccountStatus = Number($scope.CIFInvestor.AccountStatus);

        if ($scope.CIFInvestor.Sex)
            $scope.CIFInvestor.Sex = Number($scope.CIFInvestor.Sex);

        if ($scope.CIFInvestor.Religion)
            $scope.CIFInvestor.Religion = Number($scope.CIFInvestor.Religion);

        if ($scope.CIFInvestor.Education)
            $scope.CIFInvestor.Education = Number($scope.CIFInvestor.Education);

        if ($scope.CIFInvestor.MaritalStatus)
            $scope.CIFInvestor.MaritalStatus = Number($scope.CIFInvestor.MaritalStatus);

        if ($scope.CIFInvestor.Nationality)
            $scope.CIFInvestor.Nationality = Number($scope.CIFInvestor.Nationality);

        if ($scope.CIFInvestor.IDCardCountry)
            $scope.CIFInvestor.IDCardCountry = Number($scope.CIFInvestor.IDCardCountry);

        if ($scope.CIFInvestor.IDCardCity)
            $scope.CIFInvestor.IDCardCity = Number($scope.CIFInvestor.IDCardCity);

        if ($scope.CIFInvestor.DomicileCity)
            $scope.CIFInvestor.DomicileCity = Number($scope.CIFInvestor.DomicileCity);

        if ($scope.CIFInvestor.BirthDate) {
            //var date1 = $filter('date')(new Date($scope.CIFInvestor.BirthDate), 'yyyy-MM-dd');
            //$scope.CIFInvestor.ClientBirthDate1 = $scope.CIFInvestor.BirthDate.toLocaleDateString('en-US');
            //$scope.CIFInvestor.ClientBirthDate2 = $scope.CIFInvestor.BirthDate;
            //$scope.CIFInvestor.ClientBirthDate3 = date1;

            //$scope.CIFInvestor.BirthDate = date1;

            $scope.CIFInvestor.BirthDate = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
            $scope.CIFInvestor.ClientBirthDate1 = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
            $scope.CIFInvestor.ClientBirthDate2 = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
            $scope.CIFInvestor.ClientBirthDate3 = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
        }

        //if ($scope.CIFInvestor.Education == 1 || $scope.CIFInvestor.Education == 2 || $scope.CIFInvestor.Education == 3 || $scope.CIFInvestor.Education == 4 || $scope.CIFInvestor.Education == 5 || $scope.CIFInvestor.Education == 6)
        //    $scope.CIFInvestor.EducationText = '';
        if ($scope.CIFInvestor.Education != 1)
            $scope.CIFInvestor.EducationText = '';

        $scope.CIFInvestor.Stage = 1;
        $scope.CIFInvestor.IsFinished = 0;

        var SWALtranslate = $scope.SWALtranslate('ocr');

        Swal.fire({
            title: SWALtranslate.title,
            text: SWALtranslate.message,
            imageUrl: 'dist/images/sync-animate.svg',
            imageAlt: 'Preparation',
            imageHeight: 250,
            animation: false
        });

    }

    $scope.trim = function(){
        $scope.CIFInvestor.BankCabang=$scope.CIFInvestor.BankCabang?$scope.CIFInvestor.BankCabang.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BankCabang;
        $scope.CIFInvestor.BankName=$scope.CIFInvestor.BankName?$scope.CIFInvestor.BankName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BankName;
        $scope.CIFInvestor.BankNumber=$scope.CIFInvestor.BankNumber?$scope.CIFInvestor.BankNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BankNumber;
        $scope.CIFInvestor.BankOwner=$scope.CIFInvestor.BankOwner?$scope.CIFInvestor.BankOwner.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BankOwner;
        $scope.CIFInvestor.BirthPlace=$scope.CIFInvestor.BirthPlace?$scope.CIFInvestor.BirthPlace.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BirthPlace;
        $scope.CIFInvestor.Branch=$scope.CIFInvestor.Branch?$scope.CIFInvestor.Branch.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Branch;
        $scope.CIFInvestor.CompanyAddress=$scope.CIFInvestor.CompanyAddress?$scope.CIFInvestor.CompanyAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.CompanyAddress;
        $scope.CIFInvestor.CompanyName=$scope.CIFInvestor.CompanyName?$scope.CIFInvestor.CompanyName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.CompanyName;
        $scope.CIFInvestor.DomicileAddress=$scope.CIFInvestor.DomicileAddress?$scope.CIFInvestor.DomicileAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileAddress;
        $scope.CIFInvestor.DomicileKecamatan=$scope.CIFInvestor.DomicileKecamatan?$scope.CIFInvestor.DomicileKecamatan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileKecamatan;
        $scope.CIFInvestor.DomicileKelurahan=$scope.CIFInvestor.DomicileKelurahan?$scope.CIFInvestor.DomicileKelurahan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileKelurahan;
        $scope.CIFInvestor.DomicilePostalCode=$scope.CIFInvestor.DomicilePostalCode?$scope.CIFInvestor.DomicilePostalCode.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicilePostalCode;
        $scope.CIFInvestor.DomicileRT=$scope.CIFInvestor.DomicileRT?$scope.CIFInvestor.DomicileRT.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileRT;
        $scope.CIFInvestor.DomicileRW=$scope.CIFInvestor.DomicileRW?$scope.CIFInvestor.DomicileRW.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileRW;
        $scope.CIFInvestor.EducationText=$scope.CIFInvestor.EducationText?$scope.CIFInvestor.EducationText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.EducationText;
        $scope.CIFInvestor.Email=$scope.CIFInvestor.Email?$scope.CIFInvestor.Email.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Email;
        $scope.CIFInvestor.FATCA1=$scope.CIFInvestor.FATCA1?$scope.CIFInvestor.FATCA1.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FATCA1;
        $scope.CIFInvestor.FATCA2=$scope.CIFInvestor.FATCA2?$scope.CIFInvestor.FATCA2.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FATCA2;
        $scope.CIFInvestor.FATCA3=$scope.CIFInvestor.FATCA3?$scope.CIFInvestor.FATCA3.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FATCA3;
        $scope.CIFInvestor.FirstName=$scope.CIFInvestor.FirstName?$scope.CIFInvestor.FirstName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FirstName;
        $scope.CIFInvestor.FundSource=$scope.CIFInvestor.FundSource?$scope.CIFInvestor.FundSource.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FundSource;
        $scope.CIFInvestor.FundSourceText=$scope.CIFInvestor.FundSourceText?$scope.CIFInvestor.FundSourceText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FundSourceText;
        $scope.CIFInvestor.IDCardAddress=$scope.CIFInvestor.IDCardAddress?$scope.CIFInvestor.IDCardAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardAddress;
        $scope.CIFInvestor.IDCardKecamatan=$scope.CIFInvestor.IDCardKecamatan?$scope.CIFInvestor.IDCardKecamatan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardKecamatan;
        $scope.CIFInvestor.IDCardKelurahan=$scope.CIFInvestor.IDCardKelurahan?$scope.CIFInvestor.IDCardKelurahan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardKelurahan;
        $scope.CIFInvestor.IDCardNumber=$scope.CIFInvestor.IDCardNumber?$scope.CIFInvestor.IDCardNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardNumber;
        $scope.CIFInvestor.IDCardPostalCode=$scope.CIFInvestor.IDCardPostalCode?$scope.CIFInvestor.IDCardPostalCode.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardPostalCode;
        $scope.CIFInvestor.IDCardRT=$scope.CIFInvestor.IDCardRT?$scope.CIFInvestor.IDCardRT.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardRT;
        $scope.CIFInvestor.IDCardRW=$scope.CIFInvestor.IDCardRW?$scope.CIFInvestor.IDCardRW.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardRW;
        $scope.CIFInvestor.MobilePhone=$scope.CIFInvestor.MobilePhone?$scope.CIFInvestor.MobilePhone.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.MobilePhone;
        $scope.CIFInvestor.MotherName=$scope.CIFInvestor.MotherName?$scope.CIFInvestor.MotherName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.MotherName;
        $scope.CIFInvestor.NPWPNumber=$scope.CIFInvestor.NPWPNumber?$scope.CIFInvestor.NPWPNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.NPWPNumber;
        $scope.CIFInvestor.NPWPReason=$scope.CIFInvestor.NPWPReason?$scope.CIFInvestor.NPWPReason.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.NPWPReason;
        $scope.CIFInvestor.NatureOfBusinessText=$scope.CIFInvestor.NatureOfBusinessText?$scope.CIFInvestor.NatureOfBusinessText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.NatureOfBusinessText;
        $scope.CIFInvestor.Note=$scope.CIFInvestor.Note?$scope.CIFInvestor.Note.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Note;
        $scope.CIFInvestor.OccupationText=$scope.CIFInvestor.OccupationText?$scope.CIFInvestor.OccupationText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.OccupationText;
        $scope.CIFInvestor.PositionText=$scope.CIFInvestor.PositionText?$scope.CIFInvestor.PositionText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.PositionText;
        $scope.CIFInvestor.Question1=$scope.CIFInvestor.Question1?$scope.CIFInvestor.Question1.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question1;
        $scope.CIFInvestor.Question1_Text=$scope.CIFInvestor.Question1_Text?$scope.CIFInvestor.Question1_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question1_Text;
        $scope.CIFInvestor.Question2=$scope.CIFInvestor.Question2?$scope.CIFInvestor.Question2.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question2;
        $scope.CIFInvestor.Question2_Text=$scope.CIFInvestor.Question2_Text?$scope.CIFInvestor.Question2_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question2_Text;
        $scope.CIFInvestor.Question3=$scope.CIFInvestor.Question3?$scope.CIFInvestor.Question3.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question3;
        $scope.CIFInvestor.Question3_Text=$scope.CIFInvestor.Question3_Text?$scope.CIFInvestor.Question3_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question3_Text;
        $scope.CIFInvestor.Question4=$scope.CIFInvestor.Question4?$scope.CIFInvestor.Question4.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question4;
        $scope.CIFInvestor.Question4_Text=$scope.CIFInvestor.Question4_Text?$scope.CIFInvestor.Question4_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question4_Text;
        $scope.CIFInvestor.Question5=$scope.CIFInvestor.Question5?$scope.CIFInvestor.Question5.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question5;
        $scope.CIFInvestor.Question5_Text=$scope.CIFInvestor.Question5_Text?$scope.CIFInvestor.Question5_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question5_Text;
        $scope.CIFInvestor.Question6=$scope.CIFInvestor.Question6?$scope.CIFInvestor.Question6.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question6;
        $scope.CIFInvestor.Question6_Text=$scope.CIFInvestor.Question6_Text?$scope.CIFInvestor.Question6_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question6_Text;
        $scope.CIFInvestor.QuestionFATCA=$scope.CIFInvestor.QuestionFATCA?$scope.CIFInvestor.QuestionFATCA.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.QuestionFATCA;
        $scope.CIFInvestor.ReferalNumber=$scope.CIFInvestor.ReferalNumber?$scope.CIFInvestor.ReferalNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.ReferalNumber;
        $scope.CIFInvestor.SpouseCompanyAddress=$scope.CIFInvestor.SpouseCompanyAddress?$scope.CIFInvestor.SpouseCompanyAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseCompanyAddress;
        $scope.CIFInvestor.SpouseCompanyName=$scope.CIFInvestor.SpouseCompanyName?$scope.CIFInvestor.SpouseCompanyName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseCompanyName;
        $scope.CIFInvestor.SpouseCompanyPostalCode=$scope.CIFInvestor.SpouseCompanyPostalCode?$scope.CIFInvestor.SpouseCompanyPostalCode.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseCompanyPostalCode;
        $scope.CIFInvestor.SpouseFundSource=$scope.CIFInvestor.SpouseFundSource?$scope.CIFInvestor.SpouseFundSource.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseFundSource;
        $scope.CIFInvestor.SpouseFundSourceText=$scope.CIFInvestor.SpouseFundSourceText?$scope.CIFInvestor.SpouseFundSourceText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseFundSourceText;
        $scope.CIFInvestor.SpouseName=$scope.CIFInvestor.SpouseName?$scope.CIFInvestor.SpouseName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseName;
        $scope.CIFInvestor.SpouseNatureOfBusiness=$scope.CIFInvestor.SpouseNatureOfBusiness?$scope.CIFInvestor.SpouseNatureOfBusiness.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseNatureOfBusiness;
        $scope.CIFInvestor.SpouseOccupationText=$scope.CIFInvestor.SpouseOccupationText?$scope.CIFInvestor.SpouseOccupationText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseOccupationText;
        $scope.CIFInvestor.SpousePosition=$scope.CIFInvestor.SpousePosition?$scope.CIFInvestor.SpousePosition.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpousePosition;
        $scope.CIFInvestor.SpouseRelationship=$scope.CIFInvestor.SpouseRelationship?$scope.CIFInvestor.SpouseRelationship.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseRelationship;
        $scope.CIFInvestor.SpouseRelationshipText=$scope.CIFInvestor.SpouseRelationshipText?$scope.CIFInvestor.SpouseRelationshipText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseRelationshipText;
        
    }



    $scope.submit = function () {
        $scope.trim();
        $scope.prepareData();
        console.log("data", $scope.CIFInvestor);
        var urlsvc = 'service/client.svc/SaveCIF'; // 1 
        var preconfirmtranslate = "submitCif1"; // 2
        var postData = { cifdata: $scope.CIFInvestor } // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/cif/data-pekerjaan";
        });

    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: 'service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

    $scope.print = function () {
        $scope.prepareData();
        console.log($scope.CIFInvestor)
    }

}]);

